<template>
  <div class="slide-options-container">
    <div v-for="slide in slides" :key="slide.id" @click="changeTab(slide)" class="slide-options-container__option"
      :class="{ 'active': currentSlide === (slide.id - 1) }">
      <h3 v-html="slide.title" class="title">
      </h3>
    </div>
  </div>
  <div class="slide-content-container">
    <button class="slide-content-container__prev" @click="goToPreviousSlide" v-if="currentSlide !== 0"></button>
    <component :is="slides[currentSlide].component" class="slide-content-container__component" />
    <button class="slide-content-container__next" @click="goToNextSlide"
      v-if="currentSlide !== slides.length - 1"></button>
  </div>
</template>

<script>
import AnalogProductionPlan from './slides-two/AnalogProductionPlan.vue';
import DigilamVsLitholamCosts from './slides-two/DigilamVsLitholamCosts.vue';
import DigitalProductionPlanBatchPrinting from './slides-two/DigitalProductionPlanBatchPrinting.vue';
import MonthlyBatchProductionCosts from './slides-two/MonthlyBatchProductionCosts.vue';
import MultipleSkuOrderInformation from './slides-two/MultipleSkuOrderInformation.vue';

export default {
  name: 'ScenarioOne',
  components: {
    AnalogProductionPlan,
    DigitalProductionPlanBatchPrinting,
    MonthlyBatchProductionCosts,
    DigilamVsLitholamCosts,
    MultipleSkuOrderInformation,
  },
  methods: {
    changeTab(payload) {
      this.currentSlide = payload.id - 1;
    },
    goToPreviousSlide() {
      if (this.currentSlide > 0) {
        this.currentSlide -= 1;
      }
    },
    goToNextSlide() {
      if (this.currentSlide < this.slides.length - 1) {
        this.currentSlide += 1;
      }
    },
  },
  data() {
    return {
      currentSlide: 0,
      slides: [
        {
          id: 1,
          title: 'Multiple SKU order information',
          component: 'MultipleSkuOrderInformation',
        },
        {
          id: 2,
          title: 'Analog Production Plan',
          component: 'AnalogProductionPlan',
        },
        {
          id: 3,
          title: 'Digital production plan<br>with batch printing',
          component: 'DigitalProductionPlanBatchPrinting',
        },
        {
          id: 4,
          title: 'DigiLam vs<br>LithoLam costs',
          component: 'DigilamVsLitholamCosts',
        },
        {
          id: 5,
          title: 'Monthly Batch<br>Production Costs',
          component: 'MonthlyBatchProductionCosts',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/views/why-digital/manufacturing-time.scss";
</style>
